import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet"
import Header from "../components/header";

const Index = ({ children, data }) => (
  <div style={{ margin: `0 auto`, maxWidth: 650, padding: `0 1rem` }}>
    <Helmet />
    {children()}
  </div>
);

export default Index;


// WEBPACK FOOTER //
// ./src/layouts/index.js